const en = {
  'translation': {
    '404Content': 'We are sorry, but the page you are looking for doesn\'t exist.',
    '404Title': '404 - Page not found',
    'alertFeed': 'Alert Feed',
    'allRightsReserved': 'All rights reserved.',
    'automatedCalls': 'Automated Calls',
    'byWhatMeansOfCommunicationWouldYouLikeToBeReached': 'By what means of communication would you like to be reached?',
    'cancel': 'Cancel',
    'carecityAlertSubscriptionForm': 'Carecity Alert Subscription Form',
    'carecityAlertUnsubscriptionForm': 'Carecity Alert Unsubscription Form',
    'carecityio': 'https://carecity.io/en',
    'carecitySmsAndAutomatedCallsAlertSystem': 'Carecity SMS and Automated Calls Alert System',
    'chooseYourCarecityCity': 'Choose your Carecity city',
    'cityNotFound': 'This city does not exist.',
    'confirm': 'Confirm',
    'confirmationNumber': 'Confirmation Number',
    'confirmationOfYourSubscription': 'Confirmation of your subscription',
    'confirmationOfYourUnsubscription': 'Confirmation of your unsubscription',
    'confirmMySubscription': 'Confirm my subscription',
    'confirmMyUnsubscription': 'Confirm my unsubscription',
    'consent': 'By checking this box, I agree to receive communications from Carecity at this phone number. Message and data rates may apply. Text STOP to unsubscribe from messages at any time or go to the unsubsribe section of this page.',
    'credentialsMissing': 'No message can be sent from that city.',
    'enterYourAddress': 'Enter your address',
    'enterYourConfirmationNumber': 'Enter your confirmation number',
    'enterYourFullName': 'Enter your full name',
    'errorDuringSubscription': 'Error during subscription',
    'errorDuringUnsubscription': 'Error during unsubscription',
    'errorOnServer': 'An error occured while treating the request.',
    'errorYouMustEnterYour6DigitConfirmationCode': 'Error, you must enter your 6-digit confirmation code.',
    'fromWhatMeansOfCommunicationWouldYouLikeToUnsubscribe': 'From what means of communication would you like to unsubscribe?',
    'fullName': 'Full name',
    'iWouldLikeToUnsubscribeFromTheCarecityAlertServiceImmediately': 'I would like to unsubscribe from the Carecity alert service immediately',
    'moreDetails': 'More details',
    'next': 'Next',
    'pendingSubscriptionNotFound': 'Confirmation number is invalid.',
    'pendingUnsubscriptionNotFound': 'Confirmation number is invalid.',
    'phoneNumber': 'Phone number',
    'phoneNumberNotValid': 'Phone number is not valid.',
    'pleaseEnterYour6DigitConfirmationNumber': 'Please enter your 6-digit confirmation number.',
    'pleaseEnterYourAddress': 'Please enter your address.',
    'pleaseEnterYourCity': 'Please enter your city.',
    'pleaseEnterYourConsent': 'Please read and give your consent to receive communications from the selected city.',
    'pleaseEnterYourFullName': 'Please enter your full name.',
    'pleaseEnterYourMeansOfReceivingAlerts': 'Please enter your means of receiving alerts.',
    'pleaseEnterYourPhoneNumberInTheFollowingFormat': 'Please enter your phone number in the following format: +1 (123) 456-7891.',
    'previous': 'Previous',
    'smsAlerts': 'SMS Alerts',
    'smsCredentialsMissing': 'No SMS message can be sent from that city.',
    'subscribe': 'Subscribe',
    'subscriberFound': 'This subscription already exists.',
    'subscriberNotFound': 'This subscription does not exists.',
    'subscriptionCompletedSuccessfully': 'Subscription completed successfully!',
    'subscriptionDescription': 'This service allows the distribution of messages to citizens to signal, for example, a boil water advisory, an evacuation, major work, a water main break or the closure of certain streets.',
    'subscriptionTypeNotAvailableForCity': 'No subscription of this type is available for that city.',
    'tooManyFailedSubscriptionAttempts': 'There were too many failed attempts to validate that subscription.',
    'tooManyFailedUnsubscriptionAttempts': 'There were too many failed attempts to validate that unsubscription.',
    'tooManySubscriptionRequests': 'Too many subscription request have been received for that subscriber.',
    'tooManyUnsubscriptionRequests': 'Too many unsubscription request have been received for that subscriber.',
    'unsubscribe': 'Unsubscribe',
    'unsubscriptionCompletedSuccessfully': 'Unsubscription completed successfully!',
    'unsubscriptionDescription': 'I understand and accept that once I have completed my unsubscription, I will no longer be able to receive important and urgent information from my followed municipality. In order to receive alerts later, I will need to subscribe to this service again.',
  }
};

export default en;
